<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<label for="touristGuide" class="mt-3">Pilot</label>
						<ng-select
							id="touristGuide"
							name="touristGuide"
							[(ngModel)]="filters.touristGuide"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of touristGuides" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="touristGuideType" class="mt-3">Status</label>
						<ng-select
							id="touristGuideType"
							name="touristGuideType"
							[(ngModel)]="filters.touristGuideType"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of touristGuideTypes" [value]="item.id">{{
								item.name
							}}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="rates" class="mt-3">Ocena</label>
						<div class="col-md">
							<input
								type="text"
								class="form-control"
								[(ngModel)]="filters.rates"
								name="rates"
								id="rates"
							/>
						</div>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="showDeleted"
							name="showDeleted"
							[(ngModel)]="filters.showDeleted"
						>
							<option [value]="item.id" *ngFor="let item of yesno">{{ item.name }}</option>
						</select>
						<label for="showDeleted">Pokaż usunięte wydarzenia</label>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-4">
							<button type="button" class="btn btn-secondary" (click)="filtersClear()">
								Wyczyść filtry
							</button>
						</div>
						<div class="col-sm-8 text-end">
							<button type="button" class="btn btn-primary me-4" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
